import { attachDisposableEvent } from "./Common.js";

export function effect(ref, clickOutsideFn, unitVar) {
    return attachDisposableEvent((ev) => {
        const matchValue = ref.current;
        if (matchValue != null) {
            const element = matchValue;
            if (!element.contains(ev.target)) {
                clickOutsideFn();
            }
        }
    }, document, "mousedown");
}

